import { BaseDataModel } from "@domain/shared/types/BaseDataModel";

export class Region extends BaseDataModel {
	name!: string;
	branchIds?: string[];
	companyIds?: string[];
}
